import { memo } from "react"

export const ShowIfPresent = memo(({ children, value }) => {
    if (value) return children
    return <></>
})